import { type CentraPricelistCode } from "@/data/supported-pricelists"

export type PricelistIdToPricelistCodeMap = Map<number, CentraPricelistCode>

const pricelistIdToPricelistCodeMap: PricelistIdToPricelistCodeMap = new Map<
    number,
    CentraPricelistCode
>([
    [23, "aud"],
    [27, "cad"],
    [33, "chf"],
    [32, "czk"],
    [25, "dkk"],
    [31, "eur"],
    [24, "gbp"],
    [30, "jpy"],
    [29, "nok"],
    [26, "nzd"],
    [28, "pln"],
    [19, "sek"],
    [20, "usd"]
])

export default pricelistIdToPricelistCodeMap
